import moment from 'moment';
import { dateTimeInverseFormat } from '@/utilities/constants';
const makeRangeForHourOrMinutes = (start, end) => {
    return Array.from({ length: end - start + 1 }, (_, index) => index);
};
export const disabledForwardDates = (time) => {
    return time.getTime() > Date.now();
};
export const disabledBackwardDates = (time) => {
    return time.getTime() < moment().subtract(1, 'days').valueOf();
};
export const disabledBackwardDatesFromStartDate = (time, startDate) => {
    return time.getTime() < moment(startDate).valueOf();
};
export const disabledHours = (startDate) => {
    if (startDate > moment().format(dateTimeInverseFormat))
        return [];
    return makeRangeForHourOrMinutes(0, moment().hour() - 1);
};
export const disabledMinutes = (startDate) => {
    if (startDate > moment().format(dateTimeInverseFormat))
        return [];
    return makeRangeForHourOrMinutes(0, moment().minutes());
};
export const disabledCurrentDateAndForwardDates = (time) => {
    return time.getTime() >= moment().subtract(1, 'days').valueOf();
};
